import { COLOR } from '../../../helpers/colors';

const failText = {
  m: 4,
  fontSize: 36,
  color: COLOR.helperTextColor,
  textAlign: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};
const tableContainer = { marginY: 6, pb: 3 };
const styles = {
  failText,
  tableContainer,
};

export { styles };
